import { INDRAIbeAdminPipe } from '@ibe.services/ibeadmin.indra.pipe';
import { INDRAIbeAdminConfigPipe } from '@ibe.services/ibeadmin-config.indra.pipe';
import { NgModule } from '@angular/core';
@NgModule({
	imports: [],
	declarations: [
		INDRAIbeAdminPipe, 
		INDRAIbeAdminConfigPipe
	],
	exports: [
		INDRAIbeAdminPipe, 
		INDRAIbeAdminConfigPipe
	]
})
export class IBEAdminModule {}
